var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qz-service-page"},[_vm._m(0),_c('div',{staticClass:"form-wrap"},[_c('service-form')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qz-service-page__header"},[_c('div',{staticClass:"title"},[_vm._v("After-sales service")]),_c('div',{staticClass:"subtitle"},[_vm._v("售后服务")])])
}]

export { render, staticRenderFns }